import { getAuth, setPersistence, inMemoryPersistence } from 'firebase/auth';
import { app } from '../../config/firebase';

export const auth = getAuth(app);

// setPersistence may hang if IndexedDB is locked from a prior session's
// deleteDatabase call. Race against a 5s timeout so the app doesn't freeze.
export const authReady = Promise.race([
  setPersistence(auth, inMemoryPersistence),
  new Promise<void>((resolve) => setTimeout(resolve, 5000)),
]);
